import { useStore } from '@/store';
import { NOTIFICATION_MUTATION } from '@/store/mutations/mutationTypes';
import { computed, reactive } from '@vue/composition-api';
import { Notification } from '../types/vuetify/snackbar';

export const useNotification = () => {
  const store = useStore();
  const state = reactive<{ timerId: number | undefined }>({
    timerId: undefined,
  });

  const hideNotification = () => {
    store.state.notification.isShow = false;
  };

  const showNotification = (newNotification: Notification) => {
    state.timerId && clearTimeout(state.timerId);

    store.commit(NOTIFICATION_MUTATION.SHOW_NOTIFICATION, newNotification);

    state.timerId = setTimeout(() => {
      hideNotification();
    }, 10000);
  };

  return {
    notification: computed(() => store.state.notification),
    showNotification,
  };
};
